
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'cerrix-field-wrapper',
    imports: [MatIconModule, MatTooltipModule],
    templateUrl: './cerrix-field-wrapper.component.html',
    styleUrl: './cerrix-field-wrapper.component.scss'
})
export class CerrixFieldWrapperComponent {
  @Input() public label: string = '';
  @Input() public textContent: string | undefined = undefined;
  @Input() public required: boolean = false;
  @Input() public type: 'primary' | 'secondary' = 'primary';
  @Input() public info: string = '';
}
